<template>
    <Breadcrumbs main="Materials" title="Goods" />
    <div class="container-fluid">
        <div class="email-wrap">
            <div class="row">
                <goods-table />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const GoodsTable = defineAsyncComponent(() => import("@/components/materials/goods/goods-table.vue"))
</script>